module.exports = __webpack_public_path__ + "static/media/pro_service.4c1fedc6.svg";